import { useEffect, useState } from "react";
import Tabs from "../../../../Components/Tabs";
import GetIcon from "../../../../utils/Icon";
import Tab1 from "./Tab1";
import Tab2 from "./Tab2";
import Table from "./Table";
import printerimg from "../../../../assets/print.png"
import { Link, useLocation, useNavigate } from "react-router-dom";
import ApiResponseBox from "../../../../Components/ApiResponseBox";
import { usePostCreateGrnMutation, usePostSubmitGrnMutation, usePostUpdateGrnMutation } from "../../../../store/api/grnapi";
import { useGetNotSaveScreenMutation, useGetVendorAddressListMutation, usePostPurchaseOrderIDMutation } from "../../../../store/api/purchaseorderapi";
import { useGetDoctypeDetailsQuery } from "../../../../store/api/itemapi";
import Attachment from "../../../../utils/Attachment";
import { getCurrentGRN, storeCurrentGRN } from "../../../../Localstorage/Localstorage";
import PurchaseReciept from "../Edit-Purchase-Reciept/PurchaseRecipt";

const GRNForm = () => {
  const nvg = useNavigate()
  const location = useLocation();
  console.log("check locatiu h",location);
  const grn_save_id = getCurrentGRN();
  const [selectedpo, setselectedpo] = useState('');
  const [activityboll, setactivityboll] = useState(false)
  const [finalstep, setfinalstep] = useState(false);
  const [tab, settab] = useState(1)
  const [item_Rows, setitem_Rows] = useState([]);
  console.log("item_Rowsitem_Rowsitem_Rowsitem_Rowsitem_Rowsitem_Rowsitem_Rowsitem_Rows",item_Rows);
  const [ptype, setptype] = useState("Error")
  const [selectRow, setselectRow] = useState("")
  const [loader, setloader] = useState(true)
  const [error, setError] = useState('');
  const [showError, setShowError] = useState(false);
  const [pr_response, setpr_response] = useState("");
  const [vendorAddress, setvendorAddress] = useState({});
  const [fulldata, setfulldata] = useState([]);
  const [polist, setpolist] = useState([]);
  const [scanInput, setScanInput] = useState("");
  const [serialNoInput, setSerialNoInput] = useState("");
  const [scanInputTwo, setScanInputTwo] = useState("");
  const [create_grn] = usePostCreateGrnMutation()
  const [submit_grn] = usePostSubmitGrnMutation()
  const [update_grn] = usePostUpdateGrnMutation()
  const [NotSaveScreenApi] = useGetNotSaveScreenMutation();
  const [getvendor_address_list_data] = useGetVendorAddressListMutation();
  const [getAllPO] = usePostPurchaseOrderIDMutation();
  const { data: itemDetail, isLoading: itemLoader, refetch: refetchItemDetails } = useGetDoctypeDetailsQuery({ "doctype": "Item", "name": scanInputTwo });
  

  useEffect(()=>{
setselectedpo(location.state)
  },[location])
     
  useEffect(() => {
    const getdata = async () => {
      const response = await NotSaveScreenApi({ "method": "erpnext.buying.doctype.purchase_order.purchase_order.make_purchase_receipt", "source_name": selectedpo });
      setfulldata(response.data)
      let updatedRows = response.data.message?.items.map((item,index) => ({
        ...item,
        accepted_qty: 0,
        rejected_qty: 0,
        expiry_date: '',
        manufacturing_date: '',
        scanned_serials: [],
        serial_numbers: [],
        batch_no: "",
      }));
      setitem_Rows(updatedRows)

      const vendorAddressApiData = await getvendor_address_list_data({ vendor: response.data.message?.supplier })
      const selectaddress = vendorAddressApiData?.data?.result.filter((address) => address.name == response.data.message?.supplier_address);
      setvendorAddress(selectaddress[0])
      setloader(false)
    }

  
   console.log("selectedposelectedpo",selectedpo);
    if (selectedpo) {
      getdata();
    }else{
     setfulldata([]) 
     setitem_Rows([])
     setvendorAddress({})
    }
  }, [selectedpo, NotSaveScreenApi])
    console.log("dkdkkdkddk",selectedpo);

  useEffect(()=>{
  if(!selectedpo){
       const getpofun = async () =>{

         const formData = new FormData();
         formData.append("doctype", "Purchase Order");
         formData.append("fields", JSON.stringify(["name"]));
         formData.append("filters", JSON.stringify([["Purchase Order", "status", "=", "To Receive and Bill"]]));
         formData.append("order_by", "modified desc");
         formData.append("view", "List");
         formData.append("start",0);
         formData.append("view",9999999);


         const getpo = await getAllPO(formData);
        const names = getpo?.data?.message?.values.map((item) => ({ name: item[0] }));
         setpolist(names)
        }

        getpofun();
    }
  },[])

  useEffect(() => {
  if (itemDetail?.message?.has_serial_no === 1 && 
      (itemDetail?.message?.serial_no_setup === "Manual" || !itemDetail?.message?.serial_no_setup)) {
        setTimeout(() => {document.getElementById('serial-scan-input')?.focus();}, 500);
     }
}, [itemDetail]);

const handleScan = async (scannedCode) => {
  setScanInputTwo(scannedCode);
  refetchItemDetails();

  setitem_Rows(prevList => {
    const updatedList = [...prevList];
    const itemIndex = updatedList.findIndex(item => item.item_code === scannedCode);

    if (itemIndex === -1) {
      setptype("Error");
      setError(`Item ${scannedCode} not found`);
      setShowError(true);
      return prevList;
    }

    const matchedItem = updatedList[itemIndex];
    if (matchedItem.accepted_qty >= matchedItem.qty) {
      setptype("Error");
      setError(`All quantities scanned for ${scannedCode}`);
      setShowError(true);
      return prevList;
    }

    setselectRow(scannedCode);

    // Update item_Rows with new accepted_qty
    updatedList[itemIndex] = {
      ...matchedItem,
      accepted_qty: parseInt(matchedItem.accepted_qty) + 1,
    };
   
    
    setTimeout(() => {document.getElementById('serial-scan-input')?.focus();}, 300);
    setSerialNoInput('')
    return updatedList;
  });
 setTimeout(() => {
   setScanInput("");
 }, 800);
};

  const handleScanSerialNo = async (e) => {
    if (e.key === 'Enter' || e.type === 'click') {
      if (!itemDetail) {
        setptype("Error");
        setError(`Item not found`);
        setShowError(true);
        return;
      }
    }

    if (itemDetail?.message?.has_serial_no == 1) {
      if (itemDetail?.message?.serial_no_setup == "System Generated") {
        return;
      }
    } else {
      return;
    }


    if (e.key === 'Enter' || e.type === 'click') {
      e.preventDefault();
      const serialValue = e.target.value;

      if (!serialValue) {
        setptype("Error");
        setError(`Serial number cannot be empty`);
        setShowError(true);
        return;
      }

      const itemIndex = item_Rows.findIndex(item => item.item_code === itemDetail.message.item_code);
      if (itemIndex === -1) {
        setptype("Error");
        setError(`Item not found`);
        setShowError(true);
        return;
      }

      const currentItem = item_Rows[itemIndex];
      const currentSerials = currentItem.serial_numbers || [];
      const maxAllowed = Number(currentItem.accepted_qty) || 0;

      if (currentSerials.includes(serialValue)) {
        setptype("Error");
        setError(`This serial number already exists`);
        setShowError(true);
        return;
      }
      if (item_Rows[itemIndex].serial_numbers.length >= maxAllowed) {
        setptype("Error");
        setError(`You can only add ${maxAllowed} serial numbers for ${itemDetail.message.name}.`);
        setShowError(true);
        return;
      }

      setitem_Rows(prev => prev.map((item, idx) =>
        idx === itemIndex
          ? { ...item, serial_numbers: [...item.serial_numbers, serialValue] }
          : item
      ));
      setSerialNoInput("");
      setptype("Success");
      setError(`Serial number added successfully`);
      setShowError(true);
      return
    }
  };

  const CreateGRN = async () => {
    for (const item of item_Rows) {
      let apdQty = item_Rows.reduce((total, item) => { return total + Number(item?.accepted_qty); }, 0);
      if (apdQty == 0) {
        setptype("Error");
        setError(`Please ensure at least 1 item is accepted before proceeding.`);
        setShowError(true);
        return;
      }
    }
    

    for (const item of item_Rows) {
      console.log("itemssssssssssss",item);
        if (item.serial_numbers && item.serial_numbers.length > 0 && !item.batch_no) {
            setptype("Error");
            setError(`Batch number is required for item ${item.item_code}.`);
            setShowError(true);
            return;
        }
    }



    const payload = {
      order_id: selectedpo,
      items: item_Rows.map(item => ({
        item_code: item.item_code,
        received_qty: Number(item.accepted_qty),
        serial_nos: item.serial_numbers.slice(0, Number(item.accepted_qty)),
        batch_no: item.batch_no,
        manufacturing_date: item.manufacturing_date,
        expiry_date: item.expiry_date
      })),
      currency: fulldata.message.currency ? fulldata.message.currency : "",
      price_list: fulldata.message.buying_price_list ? fulldata.message.buying_price_list : "",
      cost_center:fulldata.message.cost_center ? fulldata.message.cost_center : "",
      project:fulldata.message.project ? fulldata.message.project : "",
      tax_category: fulldata.message.taxes_and_charges ? fulldata.message.taxes_and_charges : "",
      terms_and_conditions:fulldata.message.tc_name ? fulldata.message.tc_name : ""
    };
    try {
      const ResponseData = await create_grn(payload);
      if (ResponseData.error) {
        setptype("Error")
        if(ResponseData.error?.data?.message == "Lot number is required for item product wms 2."){
          setError(ResponseData.error?.data?.message.replace(/Lot/g, "batch"));
        }else{
          setError(ResponseData.error?.data?.message);
        }
        setShowError(true);
      } else {
        storeCurrentGRN(ResponseData.data.data);
        setpr_response({"result":ResponseData.data.data});
        setptype("Message");
        setError("GRN Saved Successfully");
        setShowError(true);


        setTimeout(() => {
          setptype("Error")
          setError("");
          setShowError(false);
        }, 4000);
      }


    } catch (error) {
      console.log("error", error);
    }
  }

  const SubmitPurchaseOrder = async () => {
    setactivityboll(false)
    const payload = {
      receipt_id: pr_response.result
    };
    try {
      const ResponseData = await submit_grn(payload)
      if (ResponseData.error) {
        setptype("Error")
        setError(ResponseData.error?.data?.message);
        setShowError(true);
      }

      setptype("Message")
      setError("GRN Submitted Successfully");
      setactivityboll(true);

      setShowError(true);
      setfinalstep(true);

      setTimeout(() => {
        setptype("Error")
        setError("");
        setShowError(false);
      }, 4000);


    } catch (error) {
      console.log("error ", error);
    }

  }

  const UpdatePurchaseOrder = async () => {
    for (const item of item_Rows) {
      let apdQty = item_Rows.reduce((total, item) => { return total + Number(item?.accepted_qty); }, 0);
      if (apdQty == 0) {
        setptype("Error");
        setError(`Please ensure at least 1 item is accepted before proceeding.`);
        setShowError(true);
        return;
      }
    }
    
    const payload = {
      grn_id : pr_response.result,
      items : item_Rows.map(item => ({
        item_code : item.item_code,
        qty:Number(item.accepted_qty),
        received_qty : Number(item.accepted_qty),
        serial_nos: item.serial_numbers.slice(0, Number(item.accepted_qty)),
        batch_no: item.batch_no,
        manufacturing_date: item.manufacturing_date,
        expiry_date: item.expiry_date
      })),
      currency: fulldata.message.currency ? fulldata.message.currency : "",
      price_list: fulldata.message.buying_price_list ? fulldata.message.buying_price_list : "",
      cost_center:fulldata.message.cost_center ? fulldata.message.cost_center : "",
      project:fulldata.message.project ? fulldata.message.project : "",
      tax_category: fulldata.message.taxes_and_charges ? fulldata.message.taxes_and_charges : "",
      terms_and_conditions:fulldata.message.tc_name ? fulldata.message.tc_name : ""
    };
    try {

      const ResponseData = await update_grn(payload)

      if (ResponseData.error) {
        setptype("Error")
        setError(ResponseData.error?.data?.message);
        setShowError(true);
      } else {
        setpr_response({"result":ResponseData.data.data})
        setptype("Message")
        setError("GRN Updated Successfully");
        setShowError(true);


        setTimeout(() => {
          setptype("Error")
          setError("");
          setShowError(false);
        }, 4000);
      }


    } catch (error) {
      console.log("error", error);
    }
  }




    const scannedItemOnTop = () => {
      if (!scanInputTwo) return item_Rows;
      const matchingItems = item_Rows.filter(row => row.item_code === scanInputTwo);
      const otherItems = item_Rows.filter(row => row.item_code !== scanInputTwo)
      return [...matchingItems, ...otherItems];
    };


  return (

    loader && location.state ? "" : grn_save_id ? <PurchaseReciept id={grn_save_id} /> : <>
      <Tabs />
      <div className="d-flex justify-content-between px-2 " style={{ background: "#fcfdfe" }}>
        <div className="d-flex align-items-center customizewidth">
          <p className="m-0 breadcrumb-item">Inbound</p>
          <p className="m-0 "> <GetIcon iconName="MdOutlineKeyboardArrowRight" size={14} /> </p>
          <p className="m-0 breadcrumb-item" style={{ cursor: 'pointer' }} onClick={() => { nvg('/inbound/grn/create-grn-receipt') }}>GRN List </p>
          <p className="m-0">  <GetIcon iconName="MdOutlineKeyboardArrowRight" size={14} />  </p>
          <a href="javascript:void(0);" className="pagetitle d-flex align-items-center mainpage" style={{ borderBottom: "0px solid", textWrap: "nowrap", gap: '5px' }} >
            <span style={{ color: '#391F84' }}> New GRN</span>

            <button className={`rounded-pill ${finalstep ? 'greenbtnforstatus' : 'newdesign2343'}`} > {finalstep ? "Submitted" : pr_response.result ? 'Draft' : 'New'}</button>
          </a>
        </div>

        <div className="d-flex align-items-center justify-content-end customizewidth" style={{ gap: '5px' }} >


          <p onClick={() => { nvg('/inbound/putaway/create-putaway', { state: { Grn: pr_response.result, supplier: fulldata?.message?.supplier, po: selectedpo,itemwithSerialNo:item_Rows.map(item => ({
        item_code: item.item_code,
        received_qty: Number(item.accepted_qty),
        serial_nos: item.serial_numbers.slice(0, Number(item.accepted_qty)),
        batch_no: item.batch_no,
      })) } }) }} style={{ backgroundColor: '#fff', textDecoration: 'none', display: finalstep ? "" : "none" }} className="custom-btn-00989blue m-0">

            + Create Putaway

          </p>

        
        {pr_response.result && <p
            style={{ textDecoration: "none", display: finalstep ? 'none' : "flex" }}
            className="custom-btn-00989 m-0"
            onClick={() => {UpdatePurchaseOrder() }}
          >
            <GetIcon iconName='LuFilePlus2' size={12} /> &nbsp;

            Upate
          </p>}   
        {pr_response.result && <p
            style={{ textDecoration: "none", display: finalstep ? 'none' : "flex" }}
            className="custom-btn-00989 m-0"
            onClick={() => {UpdatePurchaseOrder() }}
          >
            <GetIcon iconName='LuFilePlus2' size={12} /> &nbsp;

            Upate
          </p>}   

          <p
            style={{ textDecoration: "none", display: finalstep ? 'none' : "flex" }}
            className="custom-btn-00989 m-0"
            onClick={() => { pr_response.result ? SubmitPurchaseOrder() : CreateGRN() }}
          >
            <GetIcon iconName='LuFilePlus2' size={12} /> &nbsp;

            {pr_response.result ? 'Submit' : 'Save'}
          </p>


          <Link to="/inbound/purchaseorder/create-purchase-order" className="px-2" >
            <img src={printerimg} alt="404" style={{ width: '21px' }} />
          </Link>
        </div>
      </div>


      <div className="" style={{ width: "100%", backgroundColor: "#fff", flexGrow: '1' }}>
        <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
          <div className="d-flex justify-content-between align-items-end ">
            <ul
              className="nav nav-tabs"
              style={{ color: "white", border: "none", paddingTop: '2px' }}
            >
              <li className="nav-item-tab-custom d-flex pt-0 pb-0 align-items-end border-radius-top-corner" >
                <a className={tab == 1 ? "nav-link active-tab-custom text-white border-radius-top-corner" : "nav-link nav-link-tab-custom bg-white border-radius-top-corner"} onClick={() => { settab(1) }} href="javascript:void(0);">
                  General Details{tab == 1 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                </a>
              </li>
              <li className="nav-item-tab-custom pt-0 pb-0 d-flex align-items-end border-radius-top-corner"  >
                <a className={tab == 2 ? "nav-link active-tab-custom text-white border-radius-top-corner" : "nav-link nav-link-tab-custom bg-white border-radius-top-corner"} onClick={() => { settab(2) }} href="javascript:void(0);">
                  Address & Contact {tab == 2 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                </a>
              </li>
            </ul>
             {pr_response.result && <Attachment doctype="Purchase Receipt"  docname={pr_response.result}  /> }
          </div>
        </div>
        <div className="row d-flex justify-content-between" style={{ marginTop: '14px' }}>
          <div className="col-3 " style={{ visibility: tab == 1 ? "visible" : 'hidden', height: tab == 1 ? "auto" : '0px' }}>
            <Tab1
             po={{ 
              polist,
              selectedpo,
              setselectedpo,
              locationpo:selectedpo,
              postTime: fulldata?.message?.posting_time,
              purchaseorderid: item_Rows?.[0]?.purchase_order,
              postDate: fulldata?.message?.posting_date,fulldata,
              current_op: pr_response.result ? pr_response.result : ''
                 }}
             vendor={{ vendor: fulldata?.message?.supplier }}
             activityboll={activityboll} />
          </div>
          <div className="col-9 d-flex flex-column" style={{ visibility: tab == 1 ? "visible" : 'hidden', height: tab == 1 ? "auto" : '0px', minHeight: tab == 1 ? "400px" : '0px' }}>
            <div className="d-flex justify-content-between" style={{ gap: '5px' }}>
              <div className="d-flex" style={{ gap: '5px' }} >
                <p className="NoOfLine">No. of lines - <span style={{ color: '#2563EB' }}> {fulldata?.message?.items.length}</span></p>
                <p className="TotalQty">Total Quantity -  <span style={{ color: '#16A34A' }}> {fulldata?.message?.total_qty}</span></p>
                <p className="ReceivedQty">Scanned Quantity -  <span style={{ color: '#EC642A' }}> {item_Rows.reduce((total, item) => { return total + Number(item?.accepted_qty); }, 0)}</span></p>
              </div>
              <div className="d-flex">
                <div className="px-2 d-flex pb-2" style={{ width: '280px', position: 'relative', left: '22px' }}>
                  <input type="text" className="form-control p-0 px-2" placeholder="Scan Item" value={scanInput}
                    onChange={e => { setScanInput(e.target.value); setScanInputTwo(e.target.value); handleScan(e.target.value) }}
                    style={{ fontSize: '0.8rem', height: '34px' }} />
                  <span style={{ position: 'relative', left: "-28px", top: '3px' }}><GetIcon iconName="BsUpcScan" size={15} color="#FF8D5C" /></span>
                </div>
                <div className="px-2 d-flex pb-2" style={{ width: '280px' }}>
                  <input type="text" id="serial-scan-input" className="form-control p-0 px-2" disabled={itemDetail?.message?.has_serial_no == 1 ? false : true} placeholder="Scan Serial No." value={serialNoInput}
                    onChange={e => { setSerialNoInput(e.target.value) }} onKeyPress={handleScanSerialNo} style={{ fontSize: '0.8rem', height: '34px' }} />
                  <span style={{ position: 'relative', left: "-28px", top: '3px' }}><GetIcon iconName="BsUpcScan" size={15} color="#FF8D5C" /></span>
                </div>
              </div>
            </div>
            <div className="tableLabel">
              <div style={{ width: '99.6%', borderBottom: '1px solid #caced3', marginBottom: '6px' }}></div>
              <p style={{ color: "#1E1E1E", fontWeight: '500', marginBottom: '4px', fontSize: '15px', fontSize: '15px' }}>
                Item Details
              </p>
            </div>
            <Table
              fulldata={fulldata}
              row={{ Rows: scannedItemOnTop(), setRows: setitem_Rows, selectRow, setselectRow }}
            />


            <div className=" pb-2" style={{ marginTop: 'auto' }} >
              <div className="row mt-1" style={{ display: 'flex', flexWrap: 'wrap' }}>
                <div style={{ width: '20%' }}>
                  <p className="TotalQtywithoutBg">
                    Ordered Quantity -
                    <span style={{ color: '#EC642A' }}>
                      {fulldata?.message?.total_qty}
                    </span>
                  </p>
                </div>

                <div style={{ width: '18%' }}>
                  <p className="NoOfLinewithoutBg">
                    Total Value -
                    <span style={{ color: '#FF5969' }}>
                      {fulldata?.message?.total}
                    </span>
                  </p>
                </div>

                <div style={{ width: '24%' }}>
                  <p className="NoOfLinewithoutBg">
                    Tax Type -
                    <span style={{ color: '#C40AB8' }}>
                    {fulldata.message?.taxes.length == 0 ? '' : fulldata.message?.taxes.reduce((acc, curr) => {
                                                                                        if (!acc.includes(curr.description)) {
                                                                                            acc.push(curr.description);
                                                                                        }
                                                                                        return acc;
                                                                                        }, []).join(', ')}
                    </span>
                  </p>
                </div>

                <div style={{ width: '15%' }}>
                  <p className="NoOfLinewithoutBg">
                    Tax -
                    <span style={{ color: '#2563EB' }}>
                      {fulldata.message?.total_taxes_and_charges}
                    </span>
                  </p>
                </div>

                <div style={{ width: '22%' }}>
                  <p className="NoOfLinewithoutBg">
                    Grand Total -
                    <span style={{ color: '#16A34A' }}>
                     {fulldata.message?.grand_total}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12" style={{ visibility: tab == 2 ? "visible" : 'hidden', height: tab == 2 ? "auto" : '0px', overflow: 'hidden' }}> <Tab2 vendor_address={vendorAddress} shippingaddres={fulldata?.message?.shipping_address} /> </div>
        </div>
      </div>


      <ApiResponseBox
        poptype={ptype}
        show={showError}
        errorMessage={error}
        onClose={() => setShowError(false)}
      />
    </>
  );
};

export default GRNForm;
